/* Forged Racing — header v2: dropdowns, mobile drawer, drawer accordions */
(function () {
  'use strict';

  var CLOSE_DELAY = 150;

  function initDropdowns(header) {
    var items = header.querySelectorAll('[data-forged-dropdown]');
    var hoverCapable = window.matchMedia('(hover: hover)').matches;
    var openItem = null;

    function closeItem(item) {
      item.classList.remove('is-open');
      item.querySelector('.forged-nav-trigger').setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
    }

    function openIt(item) {
      if (openItem && openItem !== item) closeItem(openItem);
      item.classList.add('is-open');
      item.querySelector('.forged-nav-trigger').setAttribute('aria-expanded', 'true');
      openItem = item;
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.forged-nav-trigger');
      var panel = item.querySelector('.forged-nav-panel');
      var closeTimer = null;

      if (hoverCapable) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          openIt(item);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            closeItem(item);
          }, CLOSE_DELAY);
        });
      }

      /* ROUND 25: this used to be a plain toggle, which made clicking a
         mega-menu heading DISMISS the menu on any hover-capable device.
         mouseenter (above) has already applied is-open by the time the click
         lands, so the toggle always took the close branch — and because the
         trigger is a <button type="button">, nothing navigated either. The
         heading was a dead end. forged-header.liquid drives panel visibility
         solely from .is-open with no CSS :hover fallback, so nothing masked
         it. Verified live: hover opened the panel and elementFromPoint hit a
         link inside it; a real click then closed it and the hit-test fell
         through to the hero image behind.

         Hover devices now treat the click as "ensure open" — moving the
         pointer away still closes it via mouseleave, so there is no way to
         get stuck open. Touch devices keep the real toggle, because there
         tap is the only way both in and out. Not wired to navigate: MORE has
         no genuine collection destination, and inventing one would break the
         never-link-to-something-that-doesn't-exist rule. */
      trigger.addEventListener('click', function () {
        if (hoverCapable) {
          openIt(item);
          return;
        }
        if (item.classList.contains('is-open')) {
          closeItem(item);
        } else {
          openIt(item);
        }
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          openIt(item);
          var first = panel.querySelector('a');
          if (first) first.focus();
        }
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && item.classList.contains('is-open')) {
          event.stopPropagation();
          closeItem(item);
          trigger.focus();
        }
      });

      // Close when tab focus leaves the whole item
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget) && item.classList.contains('is-open')) {
          closeItem(item);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (openItem && !openItem.contains(event.target)) closeItem(openItem);
    });
  }

  function initDrawer(header) {
    var hamburger = header.querySelector('.forged-header__hamburger');
    /* ROUND 76: the drawer is no longer a child of the header — a transform on
       the header would have become the containing block for the drawer's
       position:fixed and dragged it off screen with the hide/reveal. It is
       resolved through the hamburger's own aria-controls, which already names
       it and stays correct however the markup is arranged. */
    var drawer = document.getElementById(
      hamburger ? hamburger.getAttribute('aria-controls') || '' : ''
    ) || header.parentNode.querySelector('.forged-drawer');
    if (!hamburger || !drawer) return;

    /* ROUND 56: `hamburger` and `drawer` were guarded on the line above but
       `closeButton` was not, and it is bound unguarded further down — one of the
       "cannot read properties of null (reading 'addEventListener')" shapes
       Clarity reported. The markup is not conditional, so the realistic way to
       reach it is a document that stopped parsing before the drawer's contents
       landed. Guarded alongside the other two rather than individually: with no
       close button the drawer could be opened and never dismissed, so declining
       to wire it at all is the safer failure. */
    var closeButton = drawer.querySelector('.forged-drawer__close');
    if (!closeButton) return;

    /* ROUND 64: this drawer set body.style.overflow directly while the other
       four overlays toggle the `forged-scroll-lock` class. That inline style
       never locked anything (html is the scroller — see the lock helper in
       theme.liquid), and because it bypassed the class it also missed the
       chat-launcher suppression that keys on body.forged-scroll-lock, so the
       Inbox launcher sat on top of the open menu drawer.

       Switched to the shared class: it now gets the real lock and the launcher
       suppression, and there is one scroll-lock mechanism on the site instead
       of two. */
    function open() {
      drawer.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('forged-scroll-lock');
      closeButton.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('forged-scroll-lock');
      hamburger.focus();
    }

    hamburger.addEventListener('click', open);
    closeButton.addEventListener('click', close);

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusables = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Navigating from the drawer closes it (accordion toggles are excluded)
    drawer.querySelectorAll('a.forged-sublink, a.forged-drawer__link').forEach(function (link) {
      link.addEventListener('click', close);
    });

    drawer.querySelectorAll('[data-forged-accordion]').forEach(function (group) {
      var toggle = group.querySelector('.forged-drawer__accordion');
      toggle.addEventListener('click', function () {
        var isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ROOT CAUSE FIX (recurring white gap between announcement bar and hero):
     the transparent header pulls the hero up with margin-bottom:-var(--frg-header-h),
     but that var was a hardcoded 72px while the REAL header height is driven by
     the merchant-set logo height (80px logo + 20px padding + border = 101px).
     101 - 72 = the 29px white gap. Because the logo height is editable, any
     constant is wrong the moment it changes — which is why this kept returning.
     So: measure the header and publish the real value. Self-corrects on resize,
     fullscreen, font load and logo swaps. */
  /* Publishes the real header height to --frg-header-h for the hero pull-up.
     THREE separate protections against the feedback loop this originally caused:
       1. --frg-header-h is no longer an input to the header's own layout; the
          min-height uses the static --frg-header-min instead. (primary fix)
       2. We observe the INNER row, whose size comes from its content, not from
          the variable we write.
       3. A >1px threshold, so sub-pixel churn can never re-arm a cycle.
     Note a bare threshold guard alone was NOT sufficient reasoning here: the
     old loop grew by exactly the 1px border each pass, so the circular
     dependency itself had to be broken. */
  function syncHeaderHeight(header) {
    var inner = header.querySelector('.forged-header__inner') || header;
    var root = document.documentElement;
    var applied = -1;

    function update() {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h <= 0) return;
      if (Math.abs(h - applied) <= 1) return;   // no meaningful change → no write
      applied = h;
      root.style.setProperty('--frg-header-h', h + 'px');
    }

    update();
    if (window.ResizeObserver) {
      /* observe the inner content row, NOT the outer wrapper */
      new ResizeObserver(function () {
        window.requestAnimationFrame(update);
      }).observe(inner);
    }
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    var logo = header.querySelector('.forged-header__logo img');
    if (logo && !logo.complete) logo.addEventListener('load', update);
  }

  function initTransparent(header) {
    if (!header.classList.contains('forged-header--transparent')) return;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ROUND 76 — hide on scroll down, reveal on scroll up.
     Emirali: "when u scroll down the top bar needs to scroll with you". The
     header was supposed to be sticky already but never was (see the CSS note);
     it is fixed now, and this decides when it shows. Deliberately not pinned
     open: at 390px the cookie banner, recovery bar and sticky add-to-cart bar
     are already competing for the viewport. */
  function initAutoHide(header) {
    var DELTA = 6;     /* below this a move is jitter or rubber-band, not a gesture */
    var ARM_AT = 90;   /* never hide this close to the top; also the floor of
                          the no-transition zone (see armAt below) */
    var LOCK = 'forged-scroll-lock';
    var root = document.documentElement;
    var ann = document.querySelector('.forged-announcement');
    var lastY = window.pageYOffset || 0;
    var annH = 0;
    var offset = -1;
    var ticking = false;
    var resync = false;

    function measure() {
      annH = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
    }

    function setOffset(px) {
      if (px === offset) return;              /* no redundant style writes */
      offset = px;
      root.style.setProperty('--frg-header-off', px + 'px');
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (y < 0) y = 0;                       /* iOS rubber-band overscroll */

      /* The R64 scroll lock pins <body> at position:fixed and, on release,
         restores with scrollTo(). Both ends emit a scroll event carrying a jump
         of the whole saved offset. Read as a gesture that would slam the header
         shut the instant a drawer closes, so the jump is absorbed instead. Note
         unlock() clears the class BEFORE it scrolls, so testing for the class
         here would miss the restore — hence the latch. */
      if (resync) { resync = false; lastY = y; return; }

      /* Ride below the announcement bar while any of it is still showing, so
         the fixed header never covers it. */
      var remaining = annH - y;
      setOffset(remaining > 0 ? remaining : 0);

      /* Hold the transform transition off across the whole no-hide zone, not
         just the bar itself. Dropping it the instant the bar cleared meant the
         offset's last step animated 260ms from the bar's height down to 0, so
         the header visibly slid into place after the page had already moved.
         Nothing hides below armAt anyway, so there is no transition to lose
         here — and by the time we cross it the offset is already 0, so
         re-enabling it cannot produce a jump. */
      var armAt = ARM_AT > annH ? ARM_AT : annH;
      if (y <= armAt) {
        header.classList.add('is-tracking');
        header.classList.remove('is-hidden');
        lastY = y;
        return;
      }
      header.classList.remove('is-tracking');

      var diff = y - lastY;
      /* lastY is deliberately NOT updated below the threshold, so a slow drag
         still accumulates to a gesture instead of being filtered away. */
      if (diff < DELTA && diff > -DELTA) return;
      if (diff < 0) {
        header.classList.remove('is-hidden');
      } else {
        header.classList.add('is-hidden');
      }
      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    measure();
    if (document.body) {
      var wasLocked = document.body.classList.contains(LOCK);
      new MutationObserver(function () {
        var isLocked = document.body.classList.contains(LOCK);
        if (isLocked === wasLocked) return;   /* some other body class changed */
        wasLocked = isLocked;
        resync = true;
        /* Always hand back a reachable header when an overlay opens or closes. */
        header.classList.remove('is-hidden');
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); });
    if (ann && window.ResizeObserver) new ResizeObserver(measure).observe(ann);
    update();
  }

  function initLocalization(header) {
    header.querySelectorAll('.forged-header__locale select').forEach(function (select) {
      select.addEventListener('change', function () {
        select.form && select.form.submit();
      });
    });
  }

  function init(header) {
    if (header.dataset.forgedInit) return;
    header.dataset.forgedInit = 'true';
    syncHeaderHeight(header);
    initDropdowns(header);
    initDrawer(header);
    initTransparent(header);
    initAutoHide(header);
    initLocalization(header);
  }

  function initAll() {
    document.querySelectorAll('.forged-header').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor reloads the section
  document.addEventListener('shopify:section:load', initAll);
})();
